import React, { useState } from "react";

// Get API base URL from environment
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const ModuleAccessPage = () => {
  const [writing, setWriting] = useState(false);
  const [reading, setReading] = useState(false);
  const [picture, setPicture] = useState(false);

  const handleContinue = () => {
    // Store access preferences in sessionStorage (temporary)
    const accessPrefs = {
      writing: writing ? 1 : 0,
      reading: reading ? 1 : 0,
      picture: picture ? 1 : 0,
    };

    sessionStorage.setItem("moduleAccess", JSON.stringify(accessPrefs));

    // Redirect to Google OAuth
    window.location.href = `${API_BASE_URL}/auth/login`;
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "500px", margin: "0 auto" }}>
      <h2>Welcome! Select Your Module Access</h2>
      <p>Choose which modules you'd like to access in your account:</p>

      <div style={{ marginBottom: "1rem" }}>
        <label>
          <input
            type="checkbox"
            checked={writing}
            onChange={() => setWriting(!writing)}
            style={{ marginRight: "0.5rem" }}
          />
          Writing Module
        </label>
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label>
          <input
            type="checkbox"
            checked={reading}
            onChange={() => setReading(!reading)}
            style={{ marginRight: "0.5rem" }}
          />
          Reading Module
        </label>
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label>
          <input
            type="checkbox"
            checked={picture}
            onChange={() => setPicture(!picture)}
            style={{ marginRight: "0.5rem" }}
          />
          Picture Module
        </label>
      </div>

      <button
        type="button"
        onClick={handleContinue}
        style={{
          marginTop: "1rem",
          padding: "0.5rem 1rem",
          backgroundColor: "#4285f4",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Continue with Google
      </button>
    </div>
  );
};

export default ModuleAccessPage;
